export const gmiPandas: number[] = [149, 997, 1778, 2394, 3424, 4894, 5833, 8817];